import React, { useState } from "react";
import ReactPlayer from "react-player";
import styles from './modalVideo.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'

const ModalVideo = (props) => {
  const [loading, setLoading] = useState(false);

  if (!props.show) {
    return (
      <></>
    )
  }

  return (
    <div className={styles.videoWrapper}>
      <FontAwesomeIcon icon={faTimes} className={styles.closeButton} onClick={props.onClose} />
      <div className={styles.innerContainer}>
        <ReactPlayer
          url={props.src}
          width="100%"
          height="100%"
          controls
          playing={true}
          onReady={() => {
            setLoading(false);
          }}
        />
      </div>
    </div>
  );
};

export default ModalVideo;
